import React from 'react'
import { IconDownload, IconTrash } from '@tabler/icons-react'
import pluralize from 'pluralize'

import { Card } from '@/components/cards/Card'
import { EChart } from '@/components/charts/EChart'
import { EditableHeader } from '@/components/headers/EditableHeader'
import { Button } from '@/components/buttons/Button'
import { formatTime } from '@/utils/helpers'

// TODO: Make this into a Provider/Consumer pattern
export const InsightsModule = ({
  lineChartOption,
  barChartOption,
  drillDownOption,
  handleDrillDown,
  pills,
  onDeleteTrend,
  onExportTrend,
  exportLoading,
  onUpdateTrendName,
  trend,
  countNonApplicableCalls,
  callType = 'call',
}) => {
  return (
    <Card
      compact
      title={
        <div className="flex-space-between flex-align-center">
          <EditableHeader
            initialName={lineChartOption ? lineChartOption.label : ''}
            updateName={onUpdateTrendName}
          />
        </div>
      }
      buttons={
        <div className="flex-align-center small-gap">
          <Button
            small
            square
            onClick={onExportTrend}
            loading={exportLoading}
            tooltip="Export calls (CSV)"
          >
            <IconDownload className="icon-svg pointer" data-testid="export-trend-icon" />
          </Button>
          <Button small square critical onClick={onDeleteTrend} tooltip="Delete trend">
            <IconTrash className="icon-svg pointer" data-testid="delete-trend-icon" />
          </Button>
        </div>
      }
      pills={pills}
    >
      <div className="flex-align-center medium-gap" data-testid="chart-container">
        {barChartOption && (
          <div style={{ width: '33%' }}>
            <EChart
              option={drillDownOption || barChartOption}
              events={{ click: handleDrillDown }}
            />
          </div>
        )}
        {lineChartOption && (
          <div style={{ width: '67%' }}>
            <EChart
              option={drillDownOption || lineChartOption}
              events={{ click: handleDrillDown }}
            />
          </div>
        )}
      </div>
      <div className="flex-align-center flex-space-between" style={{ marginTop: '1.5rem' }}>
        <small className="muted-text">
          {`This insight is based on data from ${trend.total_calls} ${pluralize(callType, trend.total_calls)}, ${countNonApplicableCalls} ${pluralize(callType, countNonApplicableCalls)} did not relate to the trend.`}{' '}
          Balto can make mistakes. Check important info.
        </small>

        <div className="flex-align-center medium-gap">
          <small className="muted-text">
            Created by: {trend.created_by} on {formatTime(trend.created_at)}
          </small>
        </div>
      </div>
    </Card>
  )
}
